import Vue from 'vue'
const vm=new Vue()
export default vm;


// WEBPACK FOOTER //
// ./src/utils/event.js